export default __webpack_public_path__ + "static/media/voix.7e5d43e6.jpg";